import React from 'react'

import { AmountDisplay } from '@/components/AmountDisplay'
import { AdaptedGoalTransferDTO } from '@/domain/transfer/transferTypes'

interface TransferDetailsBigAmountProps
  extends Partial<AdaptedGoalTransferDTO> {
  isLoading?: boolean
}

export const TransferDetailsBigAmount: React.FC<
  TransferDetailsBigAmountProps
> = ({ amount, isLoading = false, type, formattedFiatAmount }) => {
  const isTransferOut = type === 'transfer_out'

  return (
    <AmountDisplay
      amount={amount?.amount || '0'}
      currencyCode={amount?.currency || 'USDT'}
      skeletonActive={isLoading}
      sign={isTransferOut ? '-' : '+'}
      shouldRemoveTrailingZeros
      equivalentAmountFormatted={formattedFiatAmount}
    />
  )
}
